import { PriceComparisonCell } from '../PriceComparisonCell';
import { BrandSummaryHeaderProps, BrandSummaryTableProps } from './BrandSummaryTable.types';

import './PriceComparisonTables.css';

export function BrandSummaryHeader({ fuelTypes, scrollRef }: BrandSummaryHeaderProps) {
  return (
    <div className="price-comparison-summary-header-wrapper" ref={scrollRef}>
      <div className="price-comparison-table">
        <div className="price-comparison-table-header">
          <div className="price-comparison-header-cell price-comparison-col-division">Дивізіон</div>
          <div className="price-comparison-header-cell price-comparison-col-region">Регіон</div>
          <div className="price-comparison-header-cell price-comparison-col-province">Область</div>
          <div className="price-comparison-header-cell price-comparison-col-brand">Бренд АЗК</div>
          {fuelTypes.map(fuel => (
            <div
              key={fuel.fuel_type}
              className="price-comparison-header-cell price-comparison-col-fuel price-comparison-fuel-header"
            >
              <div>{fuel.fuel_type}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function BrandSummaryTable({ brandSummary, fuelTypes, scrollRef }: BrandSummaryTableProps) {
  if (brandSummary.length === 0) return null;

  return (
    <div className="price-comparison-summary-container">
      <div className="price-comparison-summary-table-wrapper" ref={scrollRef}>
        <table className="price-comparison-table">
          <tbody>
            {brandSummary.map((brand, index) => (
              <tr
                key={`${brand.brand_id}-${brand.brand}-${brand.province}-${index}`}
                className={`price-comparison-table-row ${brand.is_reference ? 'okko-row' : ''}`}
              >
                <td className="price-comparison-table-cell price-comparison-col-division">{brand.division || '-'}</td>
                <td className="price-comparison-table-cell price-comparison-col-region">{brand.region || '-'}</td>
                <td className="price-comparison-table-cell price-comparison-col-province">{brand.province || '-'}</td>
                <td className="price-comparison-table-cell price-comparison-col-brand price-comparison-brand-cell">
                  {brand.brand}
                </td>
                {fuelTypes.map(fuel => (
                  <td
                    key={fuel.fuel_type}
                    className="price-comparison-table-cell price-comparison-price-cell price-comparison-col-fuel"
                  >
                    <PriceComparisonCell
                      fuelPrice={brand.fuel_prices[fuel.fuel_type]}
                      brandName={brand.brand}
                      isSummary={true}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
